<template>
  <v-container class="py-0 px-5">
    <v-btn
      block
      class="mb-6"
      @click="addBlankWorker"
    >
      {{ $t('add_worker') }}
    </v-btn>
    <v-row
      v-for="(worker,i) in workers"
      :key="i"
    >
      <v-col cols="6">
        <data-selector
          v-model="worker.id"
          autofocus
          field-name="worker"
          source-type="users"
        />
      </v-col>
      <v-col
        cols="5"
      >
        <validated-text-field
          v-model="worker.hour.hour"
          field-name="hour"
          rules="required|numeric"
          type="number"
        />
      </v-col>
      <v-col
        cols="1"
      >
        <v-btn
          icon
          color="delete"
          class="mt-5"
          @click="removeWorker(worker)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'EditWorkManagementWorkers',
    props: {
      workers: Array,
    },
    methods: {
      removeWorker (item) {
        // console.log(item)
        // console.log('remove' + item.id)
        this.workers.splice(this.workers.indexOf(item), 1)
      },
      addBlankWorker () {
        this.workers.push({
          id: null,
          hour: { hour: 0 },
        })
      },
    },
  }
</script>
